import ProxyBase from '../../../../../../core/proxies/ProxyBase'

export class HighLightProxy extends ProxyBase {
  getHighLight(params) {
    return this.get('Highlight', params)
  }
}

export default new HighLightProxy('IndustryOverview/')
